<div class="change-report-container">
    <div class="heading"><h2>Change Report</h2></div>
    <app-selection (jobIdSelected)="selectJob($event)"></app-selection>
    <app-view [FeatureLayer]="FeatureLayer" [Graphic]="Graphic" *ngIf="jobId != null && jobId > 0" [jobId]="jobId"></app-view>
</div>
